import { combineReducers } from 'redux';
import hippodromeInfosReducer from './hippodromeInfos';
import hippodromeBetsReducer from './hippodromeBets';
import hippodromeBetDetailsReducer from './hippodromeBetDetails';
import betSlipReducer from './betSlipReducer';
import authorCommentsReducer from './authorComments';
import agfReducer from './agfReducer';
import probabilitiesReducer from './probabilities';
import couponsReducer from './couponsReducer';
import couponDetailReducer from './couponDetailReducer';
import resultsReducer from './resultsReducer';
import upcomingRacesReducer from './upcomingRacesReducer';
import allHippodromesReducer from './allHippodromes';
import horseCardReducer from './horseCardReducer';

export default combineReducers({
  hippodromesInfo: hippodromeInfosReducer,
  hippodromeAvailableBets: hippodromeBetsReducer,
  hippodromeBetDetails: hippodromeBetDetailsReducer,
  betSlip: betSlipReducer,
  authorComments: authorCommentsReducer,
  agf: agfReducer,
  probabilities: probabilitiesReducer,
  coupons: couponsReducer,
  couponDetail: couponDetailReducer,
  results: resultsReducer,
  upcomingRaces: upcomingRacesReducer,
  allHippodromes: allHippodromesReducer,
  horseCard: horseCardReducer
});
